// extracted by mini-css-extract-plugin
export var banner = "_29-0";
export var icon = "_29-1";
export var message = "_29-2";